import { QueryFilters } from '../interfaces';

export const DEFAULT_QUERY_FILTERS: QueryFilters = {
  textSearch: '',
  sizes: undefined,
};
